// @flow
import React from 'react';
import { get } from 'lodash';
import { Modal } from 'angieslist-react-components';
import { analyticsActions } from 'angieslist-app-platform';
import warningTriangleImg from './warning-triangle.png';
import SendEnhancedTrackEventOnce from './SendEnhancedTrackEventOnce';

const errorModalStyle = {
  fontSize: '20px',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: '1.29',
  letterSpacing: '-0.4px',
  textAlign: 'center',
  color: '#333333',
  padding: '24px',
};

type Props = {
  onClose: (e: any) => mixed,
  show: bool,
  headlineText?: string,
  detailsText?: string,
  enhanceableSegmentData?: {
    name: string,
    properties: {
      activityLocation: string,
      description: string,
      // other properties are allowed
    },
  },
  sendEnhancedTrackEvent?:
    typeof analyticsActions.sendEnhancedTrackEvent,
};

const ErrorModal = ({
  onClose,
  show,
  headlineText,
  detailsText,
  enhanceableSegmentData,
  sendEnhancedTrackEvent,
  ...rest
}: Props): any => {
  const analyticsEventName = get(enhanceableSegmentData, 'name');
  const analyticsEventProperties = get(enhanceableSegmentData, 'properties');
  const hasTrackPrerequisites =
    !!analyticsEventName && !!analyticsEventProperties && !!sendEnhancedTrackEvent;

  return (
    <If condition={show}>
      <If condition={hasTrackPrerequisites}>
        <SendEnhancedTrackEventOnce
          analyticsEventName={analyticsEventName}
          analyticsEventProperties={analyticsEventProperties}
          sendEnhancedTrackEvent={sendEnhancedTrackEvent}
        />
      </If>
      <Modal {...rest} show title=" " onHide={onClose}>
        <Modal.Header closeButton />
        <Modal.Body className="modal-body" style={errorModalStyle}>
          <img
            alt="Something went wrong."
            src={warningTriangleImg}
            style={{ paddingBottom: '32px' }}
          />
          <p style={{ fontWeight: 'bold' }}>{headlineText}</p>
          <p>{detailsText}
          </p>
        </Modal.Body>
      </Modal>
    </If>
  );
};

ErrorModal.defaultProps = {
  headlineText: 'Something went wrong.',
  detailsText: 'Please go back and try again. If you continue to get this error, contact your representative for assistance.',
};

export default ErrorModal;



// WEBPACK FOOTER //
// ./src/app/browser/ErrorModal.js